import { defineStore } from 'pinia'
import { ref } from 'vue'

export type FatalError = {
  heading: string
  message: string
  identifier?: string
  statusCode?: string | number
}

export const useGlobalStore = defineStore('global', () => {
  const fatalError = ref<FatalError | null>(null)

  function setFatalError(value: FatalError | null) {
    fatalError.value = value
  }

  return { fatalError, setFatalError }
})
